import React from "react";
import { FitAlignmentLabels } from "@seabrookstudios/pitch2table-core";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { usePublisherFitForGameVersioned } from "@seabrookstudios/pitch2table";

/**
 * @type {Record<import("@seabrookstudios/pitch2table-core").FitScoreLabel, "primary"|"secondary"|"info"|"warning"|"success"|"error">}
 */
const TierColors = {
  Strongest: "primary",
  NextBest: "secondary",
  Stretch: "info",
  LongShot: "warning",
  Unlikely: "error",
};

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/pitch2table-core").FitScoreLabel|undefined} props.tier
 */
export const ResearchPublisherFitTierChip = ({ tier }) => {
  if (!tier) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Chip label="No Data" size="small" variant="filled" color="default" />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      <Chip label={FitAlignmentLabels[tier]} size="small" variant="filled" color={TierColors[tier]} />
    </Box>
  );
};

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/pitch2table-core").PublisherId} props.publisherId
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {"filled"|"outlined"} props.variant
 */
export const PublisherFitChip = ({ publisherId, gameId, variant = "filled" }) => {
  const { data: fitScores = [] } = usePublisherFitForGameVersioned(gameId, "v4");
  const fitScore = fitScores.find((f) => f.publisherId === publisherId);
  const tier = fitScore?.label;

  if (!tier) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Chip label="No Data" variant={variant} color="default" />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      <Chip label={FitAlignmentLabels[tier]} variant={variant} color={TierColors[tier]} />
    </Box>
  );
};
